var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex } from 'shared/components';
import { SafetyForm, useSafetyPlanHasData } from 'shared/features/safety-plan';
import { InteractionSummary } from './interactionSummary';
import { InteractionDate } from './interactionDate';
import { StartTime } from './startTime';
import { EndTime } from './endTime';
import { useNoteSchemaContext, useNoteStatusContext } from 'shared/features/note';
import { noteSchema } from 'constants/note-schemas';
import { useFlagEnabled } from 'flagging/hooks';
import { ConditionalFormSection } from 'shared/features/form-deprecation';
import { useFormState } from 'react-hook-form';
import { TrackedCollapsibleCard } from 'src/shared/features/analytics';
export var UnscheduledInteractionForm = function (_a) {
    var memberId = _a.memberId;
    var errors = useFormState().errors;
    var enableSafetyPlan = useFlagEnabled('ENABLE_SAFETY_PLAN');
    var schema = useNoteSchemaContext().schema;
    var safetyPlanHasData = useSafetyPlanHasData();
    var isCnNote = schema === noteSchema.careNavigatorUnscheduled;
    var _b = useNoteStatusContext(), signed = _b.signed, fetched = _b.fetched;
    return (_jsx("form", __assign({ noValidate: true }, { children: _jsxs(Box, { children: [_jsxs(Flex, __assign({ flexDir: "row" }, { children: [_jsx(InteractionDate, {}), _jsx(StartTime, {}), !isCnNote && _jsx(EndTime, {})] })), _jsx(InteractionSummary, {}), enableSafetyPlan && (_jsx(ConditionalFormSection, __assign({ name: "safetyPlan", forceShow: fetched && !signed }, { children: _jsx(TrackedCollapsibleCard, __assign({ title: "Safety Plan", mt: 4, isOpen: safetyPlanHasData, errorsInCard: errors.safetyPlan, eventName: "Unscheduled Interaction Safety Plan", eventProperties: {
                            spring_doc_id: 'compass033',
                        } }, { children: _jsx(SafetyForm, { memberId: memberId }) })) })))] }) })));
};
